// src/data/products.js
// Array de productos para la página de producto

const products = [
  {
    id: "TIGGO_9",
    name: "TIGGO 9",
    description:
      "El Hyundai HB20 es un hatchback compacto que combina estilo moderno, eficiencia de combustible y tecnología avanzada. Con un diseño aerodinámico y un interior espacioso, es ideal para la ciudad y viajes cortos.",
    image: ("hb20.jpg"),
    section: [
      {
        title: "Seguridad",
        description:
          "El Hyundai HB20 cuenta con múltiples airbags, frenos ABS y control de estabilidad para garantizar la seguridad de sus ocupantes.",
        caracteristics: [
          {
            title: "Asistente de Tráfico Cruzado con Anticolisión (RCCA)",
            description:
              "Al retroceder, el RCCA alerta al conductor al acercamiento de un vehículo cruzando su camino hacia atrás; si necesario, los frenos se aplican automáticamente para evitar colisiones.",
          },
          {
            title: "Asistente Anticolisión de Punto Ciego (BCA)",
            description:
              "Los sensores de radar en la parte trasera se utilizan para advertir al conductor de vehículos que se acercan en el área de punto ciego y reducir el riesgo de colisión en las maniobras de cambio de carril.",
          },
          {
            title:
              "Asistente de Mantenimiento (LKA) y Centrado (LFA) de carril",
            description:
              "Los asistentes LKA y LFA ajustan automáticamente el volante para mantener el vehículo dentro del carril de circulación y centrado en el mismo.",
          },
          {
            title: "Alerta y frenado autónomo (FCA)",
            description:
              "Previene los accidentes que se pueden producir con la repentina aparición de peatones y ciclistas o cuando un vehículo frena bruscamente. Cuando estos escenarios suceden, el sistema frena el vehículo automáticamente.",
          },
        ],
      },
      {
        title: "Conectividad",
        description:
          "Satisfaciendo las necesidades de las familias y las situaciones laborales por igual, el New HB20 se actualizó con la última tecnología inteligente.",
        caracteristics: [
          {
            title: "Clúster totalmente digital",
            description:
              "Los gráficos en el grupo digital se adaptan a la nueva estética tecnologica y moderna del HB20.",
          },
          {
            title: "Pantalla táctil de 8”",
            description:
              "La pantalla táctil de infoentretenimiento de 8” está ubicada de manera óptima que le brinda fácil acceso al conductor y acompañante a la navegación y las funciones de conectividad.",
          },
          {
            title: "Cargador inalámbrico",
            description:
              "La bandeja del cargador inalámbrico de alta velocidad cuenta con una función de enfriamiento que evita el sobrecalentamiento del teléfono celular para mayor seguridad.",
          },
          {
            title: "Llave inteligente",
            description:
              "Gracias a la llave inteligente, disfrutarás de la comodidad de poder desbloquearlo a distancia sin necesidad de colocar la llave.",
          },
        ],
      },
      {
        title: "Rendimiento",
        description:
          "El Nuevo HB20 puede llevarte donde quieras ir con una poderosa eficiencia. Su motor Gamma 1.6 16V DOHC D.CVVT, con una cilindrada de 1591 cc, ofrece un rendimiento óptimo con nafta. Además, cuenta con una transmisión de 6 marchas que mejora la experiencia de conducción.",
        caracteristics: [
          {
            title: "Levas de cambio al volante",
            description:
              "Las levas de cambio al volante te permiten tener una experiencia deportiva y tecnológica mientras manejas",
          },
          {
            title: "Transmisión automática de 6 velocidades",
            description:
              "La elegante palanca de cambios tiene un diseño tradicional pero igualmente moderno y tecnológico",
          },
        ],
      },
    ],
  },
  {
    id: "HB20s",
    name: "HB20s",
    description:
      "El Hyundai HB20S es un sedán compacto que combina diseño moderno, eficiencia y tecnología avanzada, ideal para quienes buscan confort y seguridad en cada viaje.",
    image: ("hb20s.jpg"),
    section: [
      {
        title: "Seguridad",
        description:
          "El HB20S cuenta con sistemas de seguridad activa y pasiva como frenos ABS, airbags frontales, control de estabilidad y asistente de arranque en pendiente.",
        caracteristics: [
          {
            title: "Control de estabilidad (ESC)",
            description:
              "Ayuda a mantener el control del vehículo en maniobras bruscas o curvas cerradas. El sistema monitorea constantemente la trayectoria y ajusta el frenado de cada rueda para evitar derrapes y mantener la estabilidad en todo momento, incluso en condiciones adversas.",
          },
          {
            title: "Asistente de arranque en pendiente (HAC)",
            description:
              "Evita que el vehículo retroceda al soltar el freno en una pendiente. El sistema mantiene la presión de freno durante unos segundos, permitiendo un arranque suave y seguro en subidas pronunciadas.",
          },
          {
            title: "Frenos ABS con EBD",
            description:
              "Mejoran la capacidad de frenado y el control en situaciones de emergencia. El EBD distribuye la fuerza de frenado entre las ruedas para optimizar la distancia de detención y evitar el bloqueo de las ruedas.",
          },
          {
            title: "Airbags frontales",
            description:
              "Protección para conductor y acompañante en caso de colisión. Los airbags se despliegan de manera inteligente según la intensidad del impacto, minimizando el riesgo de lesiones.",
          },
        ],
      },
      {
        title: "Conectividad",
        description:
          "El HB20S ofrece conectividad avanzada para una experiencia de manejo más cómoda y entretenida.",
        caracteristics: [
          {
            title: "Pantalla táctil de 8”",
            description:
              "Compatible con Android Auto y Apple CarPlay. Permite acceder a tus aplicaciones favoritas, navegación GPS y música de manera intuitiva y segura.",
          },
          {
            title: "Bluetooth",
            description:
              "Permite conectar tu teléfono para llamadas y música. La conexión es estable y de alta calidad, facilitando la comunicación sin distracciones.",
          },
          {
            title: "Cargador USB",
            description:
              "Carga tus dispositivos fácilmente durante el viaje. El puerto USB de alta velocidad asegura que tus dispositivos estén siempre listos para usar.",
          },
          {
            title: "Controles al volante",
            description:
              "Acceso rápido a funciones multimedia y llamadas. Los botones ergonómicos permiten controlar el sistema de audio y el teléfono sin quitar las manos del volante.",
          },
        ],
      },
      {
        title: "Rendimiento",
        description:
          "El HB20S está equipado con un motor eficiente y transmisión automática o manual de 6 velocidades.",
        caracteristics: [
          {
            title: "Motor 1.6 Gamma",
            description:
              "Potencia y eficiencia para el uso diario. El motor ofrece una respuesta ágil y un consumo reducido, ideal para trayectos urbanos y viajes largos.",
          },
          {
            title: "Transmisión automática de 6 velocidades",
            description:
              "Conducción suave y eficiente. Los cambios de marcha son precisos y contribuyen a una experiencia de manejo confortable.",
          },
          {
            title: "Dirección eléctrica",
            description:
              "Mayor confort y precisión al manejar. La asistencia eléctrica se ajusta según la velocidad, facilitando las maniobras en ciudad y brindando estabilidad en ruta.",
          },
          {
            title: "Suspensión reforzada",
            description:
              "Mayor estabilidad y confort en todo tipo de caminos. La suspensión absorbe las irregularidades del terreno, asegurando un viaje placentero para todos los ocupantes.",
          },
        ],
      },
    ],
  },
  {
    id: "Creta",
    name: "Creta",
    description:
      "La Nueva Creta es una SUV compacta que destaca por su diseño audaz, tecnología de vanguardia y un alto nivel de confort y seguridad.",
    image: ("creta.jpg"),
    section: [
      {
        title: "Seguridad",
        description:
          "La Creta incorpora sistemas de seguridad activa y pasiva para proteger a todos los ocupantes.",
        caracteristics: [
          {
            title: "Control de estabilidad (ESC)",
            description:
              "Mantiene el control del vehículo en situaciones de emergencia. El sistema actúa automáticamente sobre los frenos y el motor para evitar derrapes y mantener la trayectoria deseada.",
          },
          {
            title: "Seis airbags",
            description:
              "Protección integral para conductor y pasajeros. Los airbags están distribuidos estratégicamente para cubrir todas las plazas y minimizar el riesgo de lesiones.",
          },
          {
            title: "Cámara de retroceso",
            description:
              "Facilita las maniobras de estacionamiento. La imagen en tiempo real y las guías dinámicas ayudan a evitar obstáculos y estacionar con precisión.",
          },
          {
            title: "Frenos ABS con EBD",
            description:
              "Mejoran la capacidad de frenado y el control. El sistema distribuye la fuerza de frenado para evitar el bloqueo de ruedas y mantener la estabilidad.",
          },
        ],
      },
      {
        title: "Conectividad",
        description: "Tecnología avanzada para mantenerte siempre conectado.",
        caracteristics: [
          {
            title: "Pantalla táctil de 8”",
            description:
              "Compatible con Android Auto y Apple CarPlay. Permite controlar el sistema multimedia, la navegación y las llamadas de forma sencilla.",
          },
          {
            title: "Bluetooth",
            description:
              "Conexión inalámbrica para llamadas y música. La calidad de sonido es nítida y la conexión es rápida y estable.",
          },
          {
            title: "Sistema de audio premium",
            description:
              "Sonido envolvente para todos los ocupantes. Los altavoces de alta fidelidad ofrecen una experiencia auditiva superior.",
          },
          {
            title: "Computadora de a bordo",
            description:
              "Muestra información relevante del viaje, consumo y autonomía en una pantalla digital de fácil lectura.",
          },
        ],
      },
      {
        title: "Rendimiento",
        description:
          "La Creta ofrece un motor eficiente y una conducción suave.",
        caracteristics: [
          {
            title: "Motor 1.5 MPi",
            description:
              "Eficiencia y potencia equilibradas. El motor responde con agilidad y bajo consumo, ideal para el uso diario.",
          },
          {
            title: "Transmisión automática IVT",
            description:
              "Cambios suaves y eficientes. La transmisión se adapta al estilo de manejo para optimizar el rendimiento.",
          },
          {
            title: "Dirección asistida eléctricamente",
            description:
              "Mayor confort y precisión. La asistencia varía según la velocidad, facilitando el manejo en ciudad y ruta.",
          },
          {
            title: "Suspensión reforzada",
            description:
              "Estabilidad y confort en todo tipo de caminos. La suspensión absorbe baches y mantiene la carrocería estable.",
          },
        ],
      },
    ],
  },
  {
    id: "Tucson",
    name: "Tucson",
    description:
      "El New Tucson es un SUV mediano que combina diseño innovador, tecnología de punta y un alto nivel de seguridad y confort.",
    image: ("tucson.jpg"),
    section: [
      {
        title: "Seguridad",
        description:
          "El Tucson incorpora avanzados sistemas de asistencia a la conducción y protección para todos los ocupantes.",
        caracteristics: [
          {
            title: "Frenado autónomo de emergencia (FCA)",
            description:
              "Detecta obstáculos y frena automáticamente si es necesario. El sistema utiliza sensores y cámaras para anticipar situaciones de riesgo y actuar antes de que ocurra un accidente.",
          },
          {
            title: "Asistente de mantenimiento de carril (LKA)",
            description:
              "Ayuda a mantener el vehículo dentro del carril. Corrige suavemente la dirección si detecta una salida involuntaria del carril.",
          },
          {
            title: "Seis airbags",
            description:
              "Protección integral para todos los ocupantes. Los airbags laterales y de cortina complementan la seguridad en caso de impacto.",
          },
          {
            title: "Cámara de retroceso y sensores",
            description:
              "Facilitan las maniobras de estacionamiento. Los sensores delanteros y traseros alertan sobre obstáculos cercanos.",
          },
        ],
      },
      {
        title: "Conectividad",
        description:
          "Tecnología de última generación para una experiencia conectada.",
        caracteristics: [
          {
            title: "Pantalla táctil de 10,25”",
            description:
              "Compatible con Android Auto y Apple CarPlay. La pantalla de alta resolución permite controlar todas las funciones multimedia y de navegación.",
          },
          {
            title: "Bluetooth",
            description:
              "Conexión inalámbrica para llamadas y música. Permite emparejar varios dispositivos y gestionar listas de reproducción fácilmente.",
          },
          {
            title: "Cargador inalámbrico",
            description:
              "Carga tu smartphone sin cables. El cargador está ubicado en la consola central para mayor comodidad.",
          },
          {
            title: "Sistema de audio premium",
            description:
              "Sonido envolvente de alta calidad. Los altavoces de última generación ofrecen una experiencia auditiva superior.",
          },
        ],
      },
      {
        title: "Rendimiento",
        description:
          "El Tucson ofrece motores potentes y eficientes, junto a una conducción suave.",
        caracteristics: [
          {
            title: "Motor 2.0 MPi",
            description:
              "Potencia y eficiencia para todo tipo de caminos. El motor responde con fuerza y suavidad, adaptándose a diferentes condiciones de manejo.",
          },
          {
            title: "Transmisión automática de 6 velocidades",
            description:
              "Cambios suaves y eficientes. La transmisión optimiza el consumo y el confort de marcha.",
          },
          {
            title: "Tracción delantera o integral",
            description:
              "Adaptable a diferentes condiciones de manejo. El sistema de tracción inteligente distribuye la fuerza según la necesidad.",
          },
          {
            title: "Suspensión independiente",
            description:
              "Mayor confort y estabilidad. La suspensión trasera multibrazo mejora la adherencia y el control en curvas.",
          },
        ],
      },
    ],
  },
  {
    id: "tucson_hibrido",
    name: "Tucson Híbrido",
    description:
      "Desarrollado para reducir emisiones sin renunciar a la diversión: la Tucson Híbrida eléctrica está propulsada con el motor 1.6T y con un motor eléctrico de 47,7kW para una potencia total combinada de 230CV, lo que significa que tendrás un gran rendimiento en cada viaje sin tener que preocuparte por el consumo de combustible.",
    image: ("tucson.jpg"),
    section: [
      {
        title: "Smartstream 1.6T-GDi HEV",
        description:
          "Una potencia máxima de 230 CV y un torque máximo del motor de 37,4 kgm.", caracteristics: [
            {
            },
          ],
      },
      {
        title: "e-Dynamic Drive",
        description:
          "Una mejor forma de disfrutar tu experiencia de manejo.",
        caracteristics: [
          {
            title: "e-Motion Drive",
            description:
              "El motor eléctrico brinda un excelente confort de conducción gracias a la tecnología de rendimiento mejorada. La vibración del vehículo se controla para garantizar una aceleración suave, mientras que se ha optimizado la maniobrabilidad para asegurar un giro y doblado más estable.",
          },
          {
            title: "e-DTVC",
            description:
              "Durante las curvas cerradas, los frenos y los motores trabajan en conjunto para lograr un vector de torque en la dirección de giro, mejorando el rendimiento de manejo y la seguridad al conducir."
          },
          {
            title: "e-Handling",
            description:
              "Controla el motor para asegurar el máximo agarre durante maniobras de giro bruscas, reduciendo el deslizamiento del vehículo y mejorando la respuesta de dirección y la estabilidad en las curvas."
          },
          {
            title: "e-Traction",
            description:
              "Controla el torque de tracción para mantener la adherencia óptima de cada neumático durante las curvas, mejorando el control estable y la sensibilidad de conducción dinámica.",
          },
          {
            title: "e-Ride Gen1",
            description:
              "Cuando el vehículo pasa por una loma de burro, el motor controla el movimiento para minimizar las sacudidas y lograr un viaje cómodo y estable.",
          },
          {
            title: "e-Ride Gen2",
            description:
              "El motor se controla para que el conductor sienta menos vibraciones durante la aceleración, lo que mejora la suavidad al acelerar, la comodidad de conducción y el confort a bordo.",
          },
        ],
      },
      {
        title: "Seguridad",
        description:
          "Funciones de frenado óptimas.",
        caracteristics: [
          {
            title: "Frenado regenerativo inteligente.",
            description:
              "Analiza las condiciones del tráfico y ajusta de forma autónoma el nivel de frenado regenerativo para una experiencia de conducción aún más eficiente.",
          },
          {
            title: "Contenidos exclusivos para híbridos.",
            description:
              "El sistema de infoentretenimiento muestra información sobre la conducción híbrida, como el uso del motor eléctrico y la eficiencia del combustible.",
          },
        ],
      },
    ],
  },
  {
    id: "Staria",
    name: "Staria",
    description:
      "La Hyundai Staria es una van multipropósito que destaca por su diseño futurista, gran espacio interior y tecnología avanzada.",
    image: ("staria.jpg"),
    section: [
      {
        title: "Seguridad",
        description:
          "Staria cuenta con sistemas de seguridad activa y pasiva para todos los pasajeros.",
        caracteristics: [
          {
            title: "Seis airbags",
            description:
              "Protección integral para todos los ocupantes. Los airbags laterales y de cortina brindan una cobertura total en caso de impacto.",
          },
          {
            title: "Control de estabilidad (ESC)",
            description:
              "Ayuda a mantener el control en maniobras bruscas. El sistema actúa sobre los frenos y el motor para evitar derrapes y mantener la trayectoria.",
          },
          {
            title: "Asistente de arranque en pendiente (HAC)",
            description:
              "Evita que el vehículo retroceda en pendientes. El sistema mantiene la presión de freno para facilitar el arranque en subidas.",
          },
          {
            title: "Frenos ABS con EBD",
            description:
              "Mejoran la capacidad de frenado y el control. El EBD distribuye la fuerza de frenado para optimizar la distancia de detención.",
          },
        ],
      },
      {
        title: "Conectividad",
        description:
          "Tecnología avanzada para una experiencia de viaje superior.",
        caracteristics: [
          {
            title: "Pantalla táctil de 8”",
            description:
              "Compatible con Android Auto y Apple CarPlay. Permite controlar el sistema multimedia y la navegación de forma intuitiva.",
          },
          {
            title: "Bluetooth",
            description:
              "Conexión inalámbrica para llamadas y música. La calidad de sonido es excelente y la conexión es rápida.",
          },
          {
            title: "Cargador USB",
            description:
              "Carga rápida para tus dispositivos. Los puertos están distribuidos en la cabina para mayor comodidad.",
          },
          {
            title: "Sistema de audio premium",
            description:
              "Sonido envolvente para todos los pasajeros. Los altavoces de alta fidelidad aseguran una experiencia auditiva superior.",
          },
        ],
      },
      {
        title: "Rendimiento",
        description:
          "Staria ofrece un motor potente y eficiente, ideal para viajes largos y transporte de pasajeros.",
        caracteristics: [
          {
            title: "Motor 2.2 CRDi",
            description:
              "Potencia y eficiencia para grandes distancias. El motor diésel ofrece un excelente torque y bajo consumo.",
          },
          {
            title: "Transmisión automática de 8 velocidades",
            description:
              "Conducción suave y eficiente. Los cambios de marcha son imperceptibles y contribuyen al confort de marcha.",
          },
          {
            title: "Tracción delantera",
            description:
              "Mayor estabilidad y control. El sistema de tracción mejora la adherencia en diferentes superficies.",
          },
          {
            title: "Suspensión trasera independiente",
            description:
              "Mayor confort para todos los pasajeros. La suspensión absorbe las irregularidades del camino y mantiene la estabilidad.",
          },
        ],
      },
    ],
  },
  {
    id: "Veloster",
    name: "Veloster",
    description:
      "El Hyundai Veloster N es un hatchback deportivo de alto rendimiento, diseñado para ofrecer una experiencia de conducción emocionante y dinámica.",
    image: ("veloster.jpg"),
    section: [
      {
        title: "Rendimiento",
        description:
          "El Veloster N está equipado con un motor turbo de alto rendimiento y tecnología deportiva.",
        caracteristics: [
          {
            title: "Motor 2.0 Turbo GDi",
            description:
              "250 CV de potencia y 353 Nm de torque. El motor turbo ofrece una aceleración impresionante y una respuesta inmediata al acelerador.",
          },
          {
            title: "Transmisión manual de 6 velocidades",
            description:
              "Para una experiencia de manejo deportiva. La caja de cambios está optimizada para cambios rápidos y precisos.",
          },
          {
            title: "Suspensión deportiva",
            description:
              "Mayor estabilidad y control en curvas. La suspensión ajustable permite adaptar el comportamiento del vehículo al estilo de conducción.",
          },
          {
            title: "Frenos de alto rendimiento",
            description:
              "Mayor capacidad de frenado en condiciones exigentes. Los discos ventilados y las pinzas deportivas aseguran una detención segura a altas velocidades.",
          },
        ],
      },
    ],
  },
  {
    id: "HD78",
    name: "HD78",
    description:
      "El Hyundai HD78 es un camión liviano robusto y confiable, ideal para el trabajo urbano y de media distancia.",
    image: ("hd78.jpg"),
    section: [
      {
        title: "Rendimiento",
        description:
          "El HD78 cuenta con un motor potente y eficiente, diseñado para soportar grandes cargas y ofrecer un bajo consumo de combustible.",
        caracteristics: [
          {
            title: "Motor 3.9L Turbo Diesel",
            description:
              "Potencia y torque para el trabajo pesado. El motor está optimizado para ofrecer un excelente rendimiento incluso en condiciones exigentes.",
          },
          {
            title: "Transmisión manual de 5 velocidades",
            description:
              "Robustez y eficiencia en el trabajo diario. La caja de cambios está diseñada para soportar cargas elevadas y facilitar la conducción.",
          },
          {
            title: "Chasis reforzado",
            description:
              "Mayor durabilidad y capacidad de carga. El chasis está construido con materiales de alta resistencia para soportar el uso intensivo.",
          },
          {
            title: "Suspensión reforzada",
            description:
              "Confort y estabilidad incluso con carga máxima. La suspensión está calibrada para absorber impactos y mantener la estabilidad del camión.",
          },
        ],
      },
    ],
  },
];

export default products;
